import { FC, useCallback } from 'react'
import { LinkButton } from '@/atoms/Button'
import { Image } from '@/atoms/Image'
import { Text, TitleMD } from '@/atoms/Text'
import { useSafeTrack } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGiveawayConfigData } from '@/views/PreSales/PreSalesGiveawayView/hooks/useGiveawayConfigData'

interface Props {
  theatricalSlug: string
}
export const EmptyStateGiveaway: FC<Props> = ({ theatricalSlug }) => {
  const { t } = useTranslate('tickets')
  const track = useSafeTrack()
  const giveawayData = useGiveawayConfigData({ theatricalSlug })
  const handleButtonClick = useCallback(() => {
    track('Pre-Order Tickets Button Clicked')
  }, [track])

  if (!giveawayData?.ticketFlow?.noShowtimes?.image || !giveawayData?.ticketFlow?.noShowtimes?.text) return null

  return (
    <div className="mx-auto mb-6 mt-4 grid max-w-[480px] place-items-center gap-6 text-center">
      <div className="relative w-full overflow-hidden rounded-xl sm:max-w-[320px]">
        <div className="aspect-h-9 aspect-w-16 relative">
          <Image
            className="absolute inset-0 h-full w-full object-cover"
            src={giveawayData?.ticketFlow.noShowtimes.image}
            alt=""
            width={320}
            height={180}
          />
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <TitleMD weight="bold">{t('showtimesComingSoonGiveawayEmpty', 'Showtimes Coming Soon')}</TitleMD>

        <Text className="photon-paragraph-sm md:photon-paragraph-md" color="core-gray-700">
          {giveawayData?.ticketFlow.noShowtimes.text}
        </Text>
      </div>

      <LinkButton
        onClick={handleButtonClick}
        href={`/giveaway/${theatricalSlug}`}
        className="w-fit"
        variant="oxide-primary"
      >
        {t('preOrderTickets', 'Pre-Order Tickets')}
      </LinkButton>
    </div>
  )
}
